import { type PropsWithChildren, createContext, useContext } from 'react';

import {
  MultiMeterBarChartTooltipContextData,
  MultiMeterBarChartTooltipContextDataProps,
} from '../types/state.js';

export const MultiMeterBarChartTooltipContext =
  createContext<MultiMeterBarChartTooltipContextData>(
    {} as MultiMeterBarChartTooltipContextData,
  );

export const MultiMeterBarChartTooltipProvider = ({
  children,
  data,
}: PropsWithChildren<MultiMeterBarChartTooltipContextDataProps>) => (
  <MultiMeterBarChartTooltipContext.Provider value={data}>
    {children}
  </MultiMeterBarChartTooltipContext.Provider>
);

MultiMeterBarChartTooltipProvider['displayName'] =
  'MultiMeterBarChartTooltipProvider';

export const useMultiMeterBarChartTooltipData = () =>
  useContext(MultiMeterBarChartTooltipContext);
